"use client";
import React from "react";
import { LayoutGrid } from "../ui/layout-grid";

export function LayoutGridDemo() {
  return (
    <div className="h-full py-20 w-full">
      <h2 className="text-center text-4xl lg:text-5xl font-bold mb-6">
        <span className="bg-text-gradient bg-clip-text text-transparent">
          Gallery Section
        </span>
      </h2>
      <p className="text-xl text-center text-muted-foreground max-w-2xl mx-auto">
        Here’s a glimpse of how we engage with students across India.
      </p>
      <LayoutGrid cards={cards} />
    </div>
  );
}

const SkeletonOne = () => {
  return (
    <div>
      <p className="font-bold md:text-4xl text-xl text-white">
        House in the woods
      </p>
      <p className="font-normal text-base text-white"></p>
      <p className="font-normal text-base my-4 max-w-lg text-neutral-200">
        A serene and tranquil retreat, this house in the woods offers a peaceful
        escape from the hustle and bustle of city life.
      </p>
    </div>
  );
};

const SkeletonTwo = () => {
  return (
    <div>
      <p className="font-bold md:text-4xl text-xl text-white">
        House above the clouds
      </p>
      <p className="font-normal text-base text-white"></p>
      <p className="font-normal text-base my-4 max-w-lg text-neutral-200">
        Perched high above the world, this house offers breathtaking views and a
        unique living experience. It&apos;s a place where the sky meets home,
        and tranquility is a way of life.
      </p>
    </div>
  );
};
const SkeletonThree = () => {
  return (
    <div>
      <p className="font-bold md:text-4xl text-xl text-white">
        Greens all over
      </p>
      <p className="font-normal text-base text-white"></p>
      <p className="font-normal text-base my-4 max-w-lg text-neutral-200">
        A house surrounded by greenery and nature&apos;s beauty. It&apos;s the
        perfect place to relax, unwind, and enjoy life.
      </p>
    </div>
  );
};
const SkeletonFour = () => {
  return (
    <div>
      <p className="font-bold md:text-4xl text-xl text-white">
        Rivers are serene
      </p>
      <p className="font-normal text-base text-white"></p>
      <p className="font-normal text-base my-4 max-w-lg text-neutral-200">
        A house by the river is a place of peace and tranquility. It&apos;s the
        perfect place to relax, unwind, and enjoy life.
      </p>
    </div>
  );
};

const cards = [
  {
    id: 1,
    content: <SkeletonOne />,
    className: "md:col-span-2",
    thumbnail:
      "https://d1x6q4m9kni4a2.cloudfront.net/public/collegeService_3.jpg",
    objectPosition: "md:object-center",
  },
  {
    id: 2,
    content: <SkeletonTwo />,
    className: "col-span-1",
    thumbnail:
      "https://d1x6q4m9kni4a2.cloudfront.net/public/collegeService_2.jpg",
    objectPosition: "md:object-center",
  },
  {
    id: 3,
    content: <SkeletonThree />,
    className: "col-span-1",
    thumbnail:
      "https://d1x6q4m9kni4a2.cloudfront.net/public/collegeService_1.jpg",
    objectPosition: "md:object-center",
  },
  {
    id: 4,
    content: <SkeletonFour />,
    className: "md:col-span-2",
    thumbnail:
      "https://d1x6q4m9kni4a2.cloudfront.net/public/collegeService_11.jpg",
    objectPosition: "object-right md:object-center",
  },
  {
    id: 5,
    content: <SkeletonOne />,
    className: "md:col-span-2",
    thumbnail:
      "https://d1x6q4m9kni4a2.cloudfront.net/public/collegeService_7.jpg",
    objectPosition: "md:object-center",
  },
  {
    id: 6,
    content: <SkeletonTwo />,
    className: "col-span-1",
    thumbnail:
      "https://d1x6q4m9kni4a2.cloudfront.net/public/collegeService_5.jpg",
    objectPosition: "md:object-center",
  },
];
